// src/pages/dashboardadmindata/expand/userexpand.jsx

import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector }           from "react-redux";
import Chart                                   from "chart.js/auto";
import Modal                                   from "react-bootstrap/Modal";
import { Card, CardBody }                      from "../../../components/card/card.jsx";
import { fetchAdminUserAdditionalData }        from "../../../actions/dashboardadmin_actions";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-fixedcolumns-bs5/css/fixedColumns.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";

const $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs5");
require("datatables.net-buttons");
require("datatables.net-buttons/js/buttons.colVis.min.js");
require("datatables.net-buttons/js/buttons.html5.min.js");
require("datatables.net-buttons/js/buttons.print.min.js");
require("datatables.net-buttons-bs5");
require("datatables.net-responsive");
require("datatables.net-responsive-bs5");
require("datatables.net-fixedcolumns");
require("datatables.net-fixedcolumns-bs5");

const UserExpand = React.memo(
  ({ data, labels, values, themeColor, themeColorRgb, bodyBg }) => {
    const dispatch       = useDispatch();
    const expandChartRef = useRef(null);
    const tableRef       = useRef(null);
    const modalTableRef  = useRef(null);

    const [show, setShow]       = useState(false);
    const [datelabel, setDatelabel] = useState("");

    const {
      userAdditionalData,
      loadingUserAdditionalData,
      userAdditionalDataError,
    } = useSelector((state) => ({
      userAdditionalData:        state.dashboardadmin.userAdditionalData,
      loadingUserAdditionalData: state.dashboardadmin.loadingUserAdditionalData,
      userAdditionalDataError:   state.dashboardadmin.userAdditionalDataError,
    }));

    // Chart Over Time
    useEffect(() => {
      if (!expandChartRef.current) return;
      const chart = new Chart(expandChartRef.current, {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: "Users Over Time",
              data: values,
              borderColor: themeColor,
              borderWidth: 1.5,
              pointBackgroundColor: bodyBg,
              pointBorderWidth: 1.5,
              pointRadius: 4,
              pointHoverBackgroundColor: themeColor,
              pointHoverBorderColor: bodyBg,
              pointHoverRadius: 7,
            },
          ],
        },
        options: { responsive: true, maintainAspectRatio: false },
      });
      return () => chart.destroy();
    }, [labels, values, themeColor, themeColorRgb, bodyBg]);

    // Details Over Time table
    useEffect(() => {
      if (!tableRef.current) return;
      const dt = $(tableRef.current).DataTable({
        data: [...(data?.dateswise || [])].reverse(),
        columns: [
          {
            title: "Serial Number",
            data: null,
            render: (_d, _t, _r, meta) => meta.row + 1,
          },
          { title: "Date", data: "label" },
          { title: "Number of Users", data: "value" },
          {
            title: "Details",
            data: null,
            render: (_d, _t, row) =>
              `<button class='btn btn-primary btn-sm view-details' data-row='${JSON.stringify(
                row
              )}'>View</button>`,
          },
        ],
        destroy: true,
        responsive: true,
      });

      $(tableRef.current).off("click", ".view-details");
      $(tableRef.current).on("click", ".view-details", function () {
        handleViewDetails($(this).data("row"));
      });

      return () => dt.destroy();
    }, [data]);

    // Modal table from Redux data
    useEffect(() => {
      if (loadingUserAdditionalData) return;
      if (!modalTableRef.current) return;

      const dt = $(modalTableRef.current).DataTable({
        data: userAdditionalData || [],
        columns: [
          { title: "ID",           data: "id" },
          { title: "Username",     data: "username" },
          { title: "Email",        data: "email" },
          { title: "Phone Number", data: "phone_number" },
          { title: "Age",          data: "dateOfBirth" },
          { title: "User Type",    data: "usertype" },
          {
            title: "Created",
            data:  "created",
            render: ts => {
              const d = new Date(ts * 1000);
              return d.toLocaleString("en-US", {
                month:  "2-digit",
                day:    "2-digit",
                year:   "numeric",
                hour:   "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
              });
            }
          }
        ],
        destroy:    true,
        responsive: true
      });

      return () => dt.destroy();
    }, [userAdditionalData, loadingUserAdditionalData]);

    const handleViewDetails = (rowData) => {
      const [table, startTime, endTime] = rowData.Details
        .match(/\(([^,]+),([^,]+),([^)]+)\)/)
        .slice(1);
      setDatelabel(rowData.label);
      dispatch(fetchAdminUserAdditionalData(+startTime, +endTime));
      setShow(true);
    };

    return (
      <>
        <h1>Users</h1>

        <div className="accordion mb-2" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
              >
                Chart Over Time
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body" style={{ height: '400px', overflow: 'hidden' }}>
                <canvas ref={expandChartRef} className="w-100" height="450" />
              </div>
            </div>
          </div>
        </div>

        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
              >
                Details Over Time
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <table
                  ref={tableRef}
                  className="table table-striped table-responsive w-100"
                />
              </div>
            </div>
          </div>
        </div>

        <Modal show={show} fullscreen onHide={() => setShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Users – {datelabel}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card>
              <CardBody>
                {loadingUserAdditionalData && <div className="spinner-border" />}
                {userAdditionalDataError && (
                  <div className="text-danger">{userAdditionalDataError}</div>
                )}
                {!loadingUserAdditionalData && !userAdditionalDataError && (
                  <table
                    ref={modalTableRef}
                    className="table table-striped table-responsive w-100"
                  />
                )}
              </CardBody>
            </Card>
          </Modal.Body>
        </Modal>
      </>
    );
  }
);

export default UserExpand;
